import { CANONICAL_BASE_URL } from '@/helpers/UrlHelper'
import { Item, NavItem, Separator, Wrapper } from './Breadcrumb.styles'
import { Spacing } from '@big-red-group/storefront-common-ui'
import { RichSnippetContext } from '@/context/RichSnippetContext'

type BreadcrumbProps = {
  items: { text: string; href?: string }[]
  dataTestId?: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, dataTestId }) => {
  const addSeparator = (index: number) => (index + 1 === items.length ? null : <Separator>·</Separator>)
  const getHref = (href: string) => (href.indexOf('https://') >= 0 ? href : `https://${CANONICAL_BASE_URL}${href}`)
  const { collect } = RichSnippetContext.useRichSnippetStructuredData()
  collect({
    type: 'BreadcrumbList',
    data: items.map(({ text, href }) => ({
      name: text,
      href: href && getHref(href),
    })),
  })
  return (
    <>
      <Wrapper>
        {items.map(({ text, href }, index) => (
          <div key={index}>
            {href ? <NavItem href={href}>{text}</NavItem> : <Item data-testid={dataTestId}>{text}</Item>}
            {addSeparator(index)}
          </div>
        ))}
      </Wrapper>
      <Spacing size="M" />
    </>
  )
}

export default Breadcrumb
